import React from 'react'
import {
  Button,
  Modal,
  Backdrop,
  Fade,
  CircularProgress
} from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import Trash from '@components/Icon/Trash'
import { massProcessingApi } from '@atheneum/api'

const RemoveList = ({
  item,
  page,
  openRemoveList,
  handleOpenRemoveList,
  handleCloseRemoveList,
  history
}) => {
  const [removingList, setRemovingList] = React.useState(false)
  return (
    <>
      <span
        title="Remove list"
        className={
          page === 'listView'
            ? '.mp-remove-list-buttonList'
            : 'mp-remove-list-button'
        }
        onClick={handleOpenRemoveList}>
        <Trash />
      </span>
      <Modal
        open={openRemoveList}
        onClose={handleCloseRemoveList}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}>
        <Fade in={openRemoveList}>
          <div className="mp-remove-list-model">
            <h2
              style={{
                display: 'flex',
                alignItems: 'center',
                color: '#fff'
              }}>
              <WarningIcon
                style={{
                  color: '#ff7b00',
                  fontSize: '50px',
                  marginRight: '10px'
                }}
              />
              Are you sure you want to delete this list?
            </h2>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
              <Button style={{ color: '#fff' }} onClick={handleCloseRemoveList}>
                Cancel
              </Button>

              <Button
                style={{ background: '#ff3434', color: '#fff' }}
                onClick={async () => {
                  try {
                    setRemovingList(true)
                    await massProcessingApi.removeList(item.id)
                    return page === 'massProcessing'
                      ? handleCloseRemoveList()
                      : history.push('/list')
                  } catch (error) {
                  }
                }}>
                {!removingList ? (
                  'Delete'
                ) : (
                  <CircularProgress
                    style={{ color: '#fff', width: '20px', height: '20px' }}
                  />
                )}
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  )
}

export default RemoveList
